import { render, staticRenderFns } from "./CollectionRecordAddBottom.vue?vue&type=template&id=91f7820e&scoped=true"
import script from "./CollectionRecordAddBottom.vue?vue&type=script&lang=js"
export * from "./CollectionRecordAddBottom.vue?vue&type=script&lang=js"
import style0 from "./CollectionRecordAddBottom.vue?vue&type=style&index=0&id=91f7820e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f7820e",
  null
  
)

export default component.exports